import React from 'react';
import { useParams } from 'react-router-dom';
import RaceLive from './RaceLive';

const SUPPORTED = new Set(['map', 'leaderboard']);

export default function ObsOverlay() {
  const { overlayType = '' } = useParams();
  const normalized = overlayType.toLowerCase();

  if (!SUPPORTED.has(normalized)) {
    return (
      <div className="obs-overlay obs-overlay--leaderboard">
        <div className="obs-unsupported">
          <strong>Overlay non supportato</strong>
          <span>Usa /obs/map o /obs/leaderboard.</span>
        </div>
      </div>
    );
  }

  return <RaceLive overlayMode={normalized} />;
}
